export class RestoreAccountConnectivityConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "config",
            "baseName": "config",
            "type": "ProviderRestoreAccountConnectivityConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAccountConnectivityConfig.attributeTypeMap;
    }
    constructor() {
    }
}
